var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000732422 41.0558C11.2206 40.0903 20.0333 31.2753 20.0333 20.583C20.0333 9.8895 11.2206 1.07569 0.000732422 0.110224L0.000732422 8.16587C6.79044 9.05564 12.0207 14.2848 12.0207 20.583C12.0207 25.3589 9.01326 29.5201 4.59891 31.6406L2.04815 31.6406C1.19088 31.6406 0.45673 32.1941 0.151705 32.9796C0.101468 32.9867 0.051143 32.9935 0.000732422 33.0001L0.000732422 33.792L0.000732422 34.5542L0.000732422 41.0558Z",
    fill: "#0A3690"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M33.6166 16.0128C33.6166 24.7882 26.4775 31.9273 17.6998 31.9273L1.75857 31.9273C0.78728 31.9273 0 32.7145 0 33.6858L0 23.9135L17.6998 23.9135C22.0578 23.9135 25.6041 20.3685 25.6041 16.0116C25.6041 11.6548 22.059 8.10738 17.6998 8.10738L0 8.10738L0 0.0959892L17.6998 0.0959892C26.4775 0.0959892 33.6166 7.23508 33.6166 16.0128Z",
    fill: "url(#paint0_linear_366_3536)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_366_3536",
    x1: 30.1287,
    y1: 2.42274,
    x2: -4.09442,
    y2: 25.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.226493,
    stopColor: "#02C9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABC7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b836adab1ab01ab2a3951893eba380ea.svg";
export { ForwardRef as ReactComponent };